import { render, staticRenderFns } from "./Subscribe2.vue?vue&type=template&id=4966836f"
import script from "./Subscribe2.vue?vue&type=script&lang=js"
export * from "./Subscribe2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports